const MAINTENANCE =  `Devido a uma manutenção programada, nossos sistemas estarão temporariamente indisponíveis até $time
    do dia $date. Em breve voltamos com uma plataforma feita com bastante carinho para uma nova experiência em+
    marcação de hotéis!`;
const ERROR_SALES_TOKEN = `No momento, nossos sistemas estão temporariamente indisponíveis.
    Em breve voltamos com uma plataforma feita com bastante carinho para uma nova experiência em
    marcação de hotéis!`;

const CLOSED_CART = `Desculpe-nos pela inconveniência! Estamos realizando manutenção no nosso atendimento pelo site.
 Para adquirir nossos produtos, por favor, entre em contato através da nossa central de atendimento: 0800 610 2200.
`;
export const MESSAGES = {
    MAINTENANCE,
    ERROR_SALES_TOKEN,
    CLOSED_CART,
};
